// @ts-check

/**
 * Created by idavis on 11/10/15.
 */
angular.module('relivConference').controller(
    'relivConferenceTicketDetails',
    [
        '$scope',
        '$http',
        '$log',
        '$window',
        '$location',
        '$routeParams',
        '$filter',
        'rcmLoading',
        'relivConferenceService',
        'rcmApiLibService',
        'rcmApiLibMessageService',
        'relivConferenceOrderService',
        'rcmSwitchUserService',
        'relivConferenceTicketService',
        function (
            $scope,
            $http,
            $log,
            $window,
            $location,
            $routeParams,
            $filter,
            rcmLoading,
            relivConferenceService,
            rcmApiLibService,
            rcmApiLibMessageService,
            relivConferenceOrderService,
            rcmSwitchUserService,
            relivConferenceTicketService
        ) {

            /**
             * loading
             * @type {boolean}
             */
            $scope.loading = true;

            /**
             * productOptions
             * @type {{}}
             */
            $scope.productOptions = {};

            /**
             * conferenceItems
             * @type {{}}
             */
            $scope.conferenceItems = [];
            $scope.conferenceId = null;
            $scope.conference = {};

            /**
             * ticketDetails
             * @type {{}}
             */
            $scope.ticketDetails = [];

            /**
             * ribbons
             * @type {Array}
             */
            $scope.ribbons = [];

            /**
             * newFeatures
             * @type {Array}
             */
            $scope.newFeatures = [];

            /**
             * noFeature
             * @type {boolean}
             */
            $scope.noFeature = true;

            /**
             * hasMessage
             * @type {boolean}
             */
            $scope.hasMessage = false;

            /**
             * fieldMessages
             * @type {Array}
             */
            $scope.fieldMessages = [];

            /**
             * featureSkusToAdd
             * @type {{}}
             */
            $scope.featureSkusToAdd = {};

            var messageNameSpace = 'relivConferenceTicketDetails';
            var loadingNameSpace = 'relivConferenceTicketDetails.loading';

            /**
             * uid
             * @type {number}
             */
            var uid = $routeParams.id;

            /**
             * addMessage
             * @param message
             */
            var addMessage = function (message) {
                if (!message) {
                    return;
                }
                $scope.hasMessage = true;
                rcmApiLibMessageService.addMessage(message, messageNameSpace);
            };

            /**
             * setFieldMessages
             * @param messages
             */
            var setFieldMessages = function (messages) {
                $scope.fieldMessages = messages;
            };

            /**
             * handleMessages
             * @param messages
             */
            var handleMessages = function (messages) {

                rcmApiLibMessageService.clearMessages(messageNameSpace);

                rcmApiLibMessageService.getTypeMessages(
                    messages,
                    'validatorMessage',
                    setFieldMessages
                );

                rcmApiLibMessageService.getPrimaryMessage(
                    messages,
                    addMessage
                );
            };

            /**
             *
             */
            var setSuccessMessage = function (messageValue) {
                if (!messageValue) {
                    messageValue = $filter('translate')('The ticket was successfully updated!');
                }
                var message = rcmApiLibMessageService.getDefaultMessage();
                message.code = 'success';
                message.level = 'success';
                message.value = messageValue;
                $scope.hasMessage = true;
                rcmApiLibMessageService.setMessage(message, messageNameSpace);
            };

            /**
             * onApiError
             * @param response
             */
            var onApiError = function (response) {
                $scope.loading = false;
                handleMessages(response.messages);
            };

            /**
             *
             * @param primaryMessage
             * @param messages
             */
            var alert = function (primaryMessage, messages) {
                // no alert
                // if (!primaryMessage) {
                //     var primaryMessageObject = rcmApiLibMessageService.getPrimaryMessage(
                //         messages
                //     );

                //     primaryMessage = primaryMessageObject.value;
                // }

                // if (!primaryMessage) {
                //     primaryMessage = 'An error occurred:';
                // }

                // primaryMessage = '<div class="text-danger">' + primaryMessage + '</div>';

                // var validatorMessages = rcmApiLibMessageService.getTypeMessages(
                //     messages,
                //     'validatorMessage'
                // );

                // var messageContent = primaryMessage;

                // if (validatorMessages) {
                //     messageContent = '';
                //     for (var key in validatorMessages) {
                //         for (var i = 0; i < validatorMessages[key].length; i++) {
                //             messageContent = messageContent
                //                 + '- ' + validatorMessages[key][i]
                //                 + ' (' + key + ')' + '<br>';
                //         }
                //     }
                // }

                // messageContent = '<div class="text-danger">' + messageContent + '</div>';

                // jQuery().alert(
                //     messageContent,
                //     undefined,
                //     primaryMessage
                // );
            };

            /**
             * onConferenceSuccess
             * @param response
             * @param onSuccess
             */
            var onConferenceSuccess = function (response, onSuccess) {
                rcmApiLibMessageService.clearMessages(messageNameSpace);
                $scope.conferenceId = response.data.id;
                $scope.conference = response.data;
                var str = $scope.conference.ticketProduct.optionGroups[0].name;
                //ticket type
                $scope.type = str.replace(/"/g, '');

                $scope.productOptions = relivConferenceService.indexAvailableSkusForExistingTickets(
                    $scope.conference,
                    $scope.conferenceItems
                );

                onSuccess($scope.conference);
            };

            /**
             * getConference
             */
            var getConference = function (conferenceId, onSuccess) {
                relivConferenceService.getConference(
                    conferenceId,
                    function (response) {
                        $scope.loading = false;
                        onConferenceSuccess(response, onSuccess);
                    },
                    onApiError
                );
            };

            /**
             * ticketOptions
             * @type {{hearingImpaired: *[]}}
             */
            $scope.ticketOptions = relivConferenceService.ticketOptions;

            /**
             * dataPrepOptionsForDisplay
             * @param option
             */
            var dataPrepOptionsForDisplay = function (option) {
                if (option == false) {
                    option = 0;
                } else if (option == true) {
                    option = 1;
                }
                return option;
            };

            /**
             * prepareTicket
             * @param ticket
             * @param conference
             */
            var prepareTicket = function (ticket, conference) {
                ticket.hearingImpaired = dataPrepOptionsForDisplay(
                    ticket.hearingImpaired
                );
                ticket.signLanguage = dataPrepOptionsForDisplay(
                    ticket.signLanguage
                );
                ticket.active = dataPrepOptionsForDisplay(
                    ticket.active
                );

                $scope.noFeature = checkIfFeatureExists(
                    ticket.activeFeatures
                );
                prepareFeatures(ticket, conference);
            };

            var prepareFeatures = function (ticketDetails, conference) {
                var featureProductSkus = {};
                angular.forEach(
                    conference.featureProducts,
                    function (product, pkey) {
                        if (!featureProductSkus[product.productId]) {
                            featureProductSkus[product.productId] = {};
                            featureProductSkus[product.productId].name = product.optionGroups[0].name;
                            featureProductSkus[product.productId].skus = {};
                            featureProductSkus[product.productId].selectedSku = null;
                        }
                        angular.forEach(
                            product.skus,
                            function (sku, skey) {
                                featureProductSkus[product.productId].skus[sku.number] = {
                                    selected: false,
                                    value: sku.options[0].optionValue,
                                    price: sku.formattedPrice,
                                    sku: sku,
                                };
                            }
                        );

                    }
                );

                angular.forEach(
                    featureProductSkus,
                    function (featureProductSku, pkey) {
                        angular.forEach(
                            featureProductSku.skus,
                            function (sku, skey) {
                                angular.forEach(
                                    ticketDetails.activeFeatures,
                                    function (feature, key) {
                                        featureProductSku.selectedSku = feature.skuNumber;
                                        if (!featureProductSku.skus[feature.skuNumber]) {
                                            console.error(feature.skuNumber + ': not in list');
                                        } else {
                                            featureProductSku.skus[feature.skuNumber].selectedSku = true;
                                        }
                                    }
                                );
                            }
                        );
                    }
                );

                ticketDetails.featureProductSkus = featureProductSkus;
            };

            /**
             *
             * @param response
             */
            var onGetTicketDetailsSuccess = function (response) {
                var ticket = response.data;
                getConference(
                    ticket.conferenceId,
                    function (conference) {
                        onGetTicketDetailsConferenceSuccess(ticket, conference);
                    }
                );
            };

            /**
             * onGetTicketDetailsConferenceSuccess
             * @param ticket
             * @param conference
             */
            var onGetTicketDetailsConferenceSuccess = function (ticket, conference) {
                prepareTicket(ticket, conference);
                getRibbonData(ticket.ownerRcn);
                $scope.ticketDetails = ticket;
            };

            /**
             * onGetTicketDetailsError
             * @param response
             * @param status
             */
            var onGetTicketDetailsError = function (response, status) {
                if (status == 401) {
                    $window.location.href = '/login?redirect='
                        + encodeURIComponent(
                            '/conference/check-in#/conference/ticket'
                        );
                    return;
                }
                onApiError(response);
            };

            /**
             * getTicketDetails
             * @param uid
             */
            var getTicketDetails = function (uid) {
                $scope.loading = true;

                relivConferenceTicketService.getTicket(uid, onGetTicketDetailsSuccess, onGetTicketDetailsError);
            };

            var onGetRibbonSuccess = function (response) {
                $scope.ribbons = response.data;
            };

            var onGetRibbonError = function (response, displayRcn) {
                console.error('Ribbon not found for: ' + displayRcn);
            };

            var getRibbonData = function (displayRcn) {
                relivConferenceTicketService.getRibbon(
                    displayRcn,
                    onGetRibbonSuccess,
                    function (response) {
                        onGetRibbonError(response, displayRcn);
                    }
                );
            };

            /**
             * checkIfFeatureExists
             * @param feature
             */
            var checkIfFeatureExists = function (feature) {
                if (feature != null) {
                    return feature.length == 0;
                }
            };

            /**
             * goToListPage
             */
            var goToListPage = function () {
                $window.location.href = '/conference/check-in#/conference/ticket';
            };

            /**
             * backButton
             */
            $scope.backButton = function () {
                goToListPage();
            };

            /**
             * onAddFeatureSuSuccess
             * @param response
             */
            var onAddFeatureSuSuccess = function (response) {
                // Add to cart
                relivConferenceOrderService.addFeatures(
                    $scope.ticketDetails,
                    $scope.newFeatures,
                    onAddFeatureSkuSuccess,
                    onAddFeatureSkuError
                );
            };

            /**
             * onAddFeatureSuError
             * @param response
             */
            var onAddFeatureSuError = function (response) {
                rcmLoading.setLoading(
                    loadingNameSpace,
                    1
                );
                $scope.loading = false;
                handleMessages(response.messages);
            };

            /**
             * onAddFeatureSkuSuccess
             * @param feature
             * @param response
             */
            var onAddFeatureSkuSuccess = function (feature, response) {
                $window.alert(
                    'You will now be redirected to checkout to pay for the party tickets that were added.'
                );
                $window.location.href = '/cart#/my-cart';
            };

            /**
             * onAddFeatureSkuError
             * @param response
             */
            var onAddFeatureSkuError = function (response) {
                rcmLoading.setLoading(
                    loadingNameSpace,
                    1
                );
                $scope.loading = false;
                handleMessages(response.messages);
            };

            /**
             *
             * onUpdateTicketSuccess
             */
            var onUpdateTicketSuccess = function (response, ticket) {
                prepareTicket(ticket, $scope.conference);
                rcmApiLibMessageService.clearMessages(
                    messageNameSpace
                );
                setSuccessMessage();
                $scope.ticketForm.$setPristine();
                $scope.ticketDetails = response.data;
                addNewFeatureSkus();
            };

            /**
             * onUpdateTicketError
             */
            var onUpdateTicketError = function (response) {
                onApiError(response);
                alert('An error occurred while saving', response.messages);
            };

            /**
             * onDeleteTicketSuccess
             * @param response
             */
            var onDeleteTicketSuccess = function (response) {
                rcmApiLibMessageService.clearMessages(
                    messageNameSpace
                );
                setSuccessMessage();
                goToListPage();
            };

            /**
             * onDeleteTicketError
             * @param response
             */
            var onDeleteTicketError = function (response) {
                onApiError(response);
                alert('An error occurred while saving', response.messages);
            };

            /**
             * addNewFeatureSkus
             */
            var addNewFeatureSkus = function () {
                if ($scope.newFeatures.length < 1) {
                    return;
                }
                rcmLoading.setLoading(
                    loadingNameSpace,
                    0
                );
                $scope.loading = true;
                //rcmApiLibMessageService.clearMessages(messageNameSpace);

                // SU to owner
                switchUser(
                    $scope.ticketDetails.ownerRcn,
                    onAddFeatureSuSuccess,
                    onAddFeatureSuError
                );
            };

            /**
             * updateTicket
             * @param ticket
             */
            $scope.updateTicket = function (ticket) {
                relivConferenceTicketService.updateTicket(
                    ticket,
                    function (response) {
                        onUpdateTicketSuccess(response, ticket);
                    },
                    onUpdateTicketError
                );
            };

            /**
             * deleteTicket
             * @param ticket
             */
            $scope.deleteTicket = function (ticket) {

                var confirmed = $window.confirm(
                    'Are you sure you want to delete this ticket?'
                );
                if (!confirmed) {
                    return;
                }

                relivConferenceTicketService.deleteTicket(
                    ticket,
                    onDeleteTicketSuccess,
                    onDeleteTicketError
                );
            };

            /**
             * switchUser
             * @param ownerRcn
             * @param onSuccess
             * @param onError
             *
             * We un-SU them first to avoid an error that happens if they
             * already SUed as someone else.
             */
            var switchUser = function (ownerRcn, onSuccess, onError) {
                function next() {
                    rcmSwitchUserService.switchUser(ownerRcn, onSuccess, onError);
                }

                rcmSwitchUserService.switchUserBack(null, next, next);
            };

            /**
             * addFeature
             * @param feature
             */
            $scope.addFeature = function (feature) {
                if (!feature) {
                    return;
                }
                var newFeature = angular.copy(feature);
                $scope.newFeatures.push(newFeature);
            };

            /**
             * removeFeature
             * @param feature
             */
            $scope.removeFeature = function (feature) {
                var index = $scope.newFeatures.indexOf(feature);
                $scope.newFeatures.splice(index, 1);
            };

            /**
             * checkIn
             * @param ticket
             */
            $scope.checkIn = function (ticket) {
                if ($scope.ticketForm.$dirty) {
                    $window.alert(
                        'Please save changes before checking in.'
                    );
                    return;
                }
                ticket.checkedIn = true;
                $scope.updateTicket(ticket);
            };

            /**
             * done
             */
            $scope.done = function () {
                $location.path('/conference/ticket');
            };

            /**
             * init
             */
            var init = function () {
                getTicketDetails(uid);
            };

            init();
        },
    ]
);
